import { VneValidator } from './vneValidator';
import { registeredVneFieldValidators } from './fieldValidators';

export const registeredVneValidator = new VneValidator(
  registeredVneFieldValidators,
);
